import DetectSubjectManagement from './detect_subject_management'

export default {
  "detect_subject_management": DetectSubjectManagement
}



// WEBPACK FOOTER //
// ./src/pages/detect_subject_management/index.js